import { useState } from "react";
import { Alert, Dropdown, DropdownButton } from "react-bootstrap";

import ConfirmationModal from "./ConfirmationModal";
import TooltipProvider from "./TooltipProvider";

interface ProjectActionsDropdownProps {
  archived: boolean;
  onArchive: () => void;
  onRestore: () => void;
  archivePending?: boolean;
  restorePending?: boolean;
  // Renders an "Edit name" item when provided.
  onEditName?: () => void;
  // When set, disables the whole menu and explains why in a tooltip.
  disabledReason?: string;
}

const ProjectActionsDropdown = ({
  archived,
  onArchive,
  onRestore,
  archivePending,
  restorePending,
  onEditName,
  disabledReason,
}: ProjectActionsDropdownProps) => {
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  return (
    <>
      <TooltipProvider tooltip={disabledReason}>
        <div>
          <DropdownButton
            align="end"
            variant="secondary"
            title="Actions"
            disabled={!!disabledReason}
          >
            {onEditName && (
              <Dropdown.Item onClick={onEditName}>
                <i className="bi-pencil me-2" />
                Edit name
              </Dropdown.Item>
            )}
            {archived ? (
              <Dropdown.Item onClick={onRestore} disabled={restorePending}>
                <i className="bi-arrow-counterclockwise me-2" />
                Restore
              </Dropdown.Item>
            ) : (
              <Dropdown.Item
                className="text-danger"
                onClick={() => setShowArchiveModal(true)}
                disabled={archivePending}
              >
                <i className="bi-archive me-2" />
                Archive
              </Dropdown.Item>
            )}
          </DropdownButton>
        </div>
      </TooltipProvider>

      <ConfirmationModal
        show={showArchiveModal}
        onCancel={() => setShowArchiveModal(false)}
        onConfirm={() => {
          setShowArchiveModal(false);
          onArchive();
        }}
        confirmLabel="Archive Project"
        confirmVariant="danger"
      >
        <Alert variant="danger">
          <Alert.Heading>
            <i className="bi-exclamation-triangle me-2" />
            DANGER
            <i className="bi-exclamation-triangle ms-2" />
          </Alert.Heading>
          <p>Archiving this Project will immediately disable all its Agents.</p>
          <p>Are you sure you want to archive this Project?</p>
        </Alert>
      </ConfirmationModal>
    </>
  );
};

export default ProjectActionsDropdown;
